import * as React from "react";
import { UpdateExpressFormTemplateProc } from "@/templates/ExpressFormTemplate";
import { SPContext } from "@/store/SPProvider";
import { AccountDetails } from "./AccountDetails";
import { makeDocument } from "@/mock-data";

export interface ISingleAccountForm {
  readonly navAfterAccount: () => void;
  readonly onSectionClick: (section: string) => void;
  readonly updateTemplate: UpdateExpressFormTemplateProc;
}

export function SingleAccountForm({
  navAfterAccount,
  updateTemplate,
  onSectionClick,
}: ISingleAccountForm): React.ReactElement | null {
  const { state } = React.useContext(SPContext);
  if (!state.id) return null;

  return (
    <AccountDetails
      serviceProvider={state}
      next={navAfterAccount}
      updateTemplate={updateTemplate}
      onSectionClick={onSectionClick}
      uploadedFileInfo={() => Promise.resolve(makeDocument())} // TODO
    />
  );
}
